import ReplayIcon from "./images/icons/reply.svg?react";
import classes from "./ReplayButton.module.scss";
import { ButtonHTMLAttributes } from "react";
export const ReplayButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return (
    <button type="button" {...props} className={classes.button}>
      <ReplayIcon />
    </button>
  );
};
